import { render, staticRenderFns } from "./SecSellerInfo.vue?vue&type=template&id=23172516&scoped=true&"
import script from "./SecSellerInfo.vue?vue&type=script&lang=js&"
export * from "./SecSellerInfo.vue?vue&type=script&lang=js&"
import style0 from "./SecSellerInfo.vue?vue&type=style&index=0&id=23172516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23172516",
  null
  
)

export default component.exports